// extracted by mini-css-extract-plugin
module.exports = {"iframeWrapper":"Qp-z"};